import { Modal, ModalDialog, DialogContent, DialogTitle, FormControl, FormLabel, Input, Grid, Drawer, ModalClose, Divider, Checkbox, DialogActions, Button, Box, Textarea } from "@mui/joy";
import React from "react";
import { Util } from "../Helpers/Util";

interface NotesDialogProps {
	notesId: string;
	close: Function;
	buildingId: string;
}

interface NotesRecord {
	notes_id: string;
	buildings_id: string;
	title: string;
	description: string;
}
export default function NotesDialog(props: NotesDialogProps) {
	const [note, setNote] = React.useState<NotesRecord>();
	const [open, setOpen] = React.useState(false);

	React.useEffect(() => {
		if (!Util.isNullOrEmpty(props.notesId)) {
			fetch("Building/GetNote", {
				method: "Post",
				cache: "no-cache",
				headers: {
					"Content-Type": "application/json",
				},
				body: JSON.stringify(props.notesId),
			})
				.then((x) => x.json())
				.then((x) => {
					setNote(x as NotesRecord);
					setOpen(true);
				});
		} else {
			setNote({} as NotesRecord);
			setOpen(true);
		}
	}, []);

	const deleteNote = () => {
		if (!window.confirm("Are you sure you want to delete this note? This cannot be undone.")) return;

		fetch("Building/DeleteNote", {
			method: "Post",
			headers: {
				"Content-Type": "application/json",
			},
			cache: "no-cache",
			body: JSON.stringify(props.notesId),
		}).then((x) => close());
	};

	const save = () => {
		if (!note) return;
		note.buildings_id = props.buildingId;

		fetch("Building/SaveNote", {
			method: "Post",
			headers: {
				"Content-Type": "application/json",
			},
			cache: "no-cache",
			body: JSON.stringify({ noteData: note }),
		}).then((x) => close());
	};

	const close = () => {
		props.close();
	};

	const sizes = {
		sm: 12,
		md: 6,
	};

	const threeSizes = {
		sm: 12,
		md: 6,
		lg: 4,
	};
	return (
		<>
			<Drawer anchor="right" open={open} size="lg">
				<ModalClose onClick={close} />
				<DialogTitle>Note Form</DialogTitle>
				<DialogContent sx={{ padding: 2 }}>
					{note && (
						<Grid container spacing={2} sx={{ overflowX: "hidden" }}>
							<Grid {...sizes}>
								<FormControl>
									<FormLabel>Title</FormLabel>
									<Input
										value={note.title}
										onChange={(event) => {
											setNote({ ...note, title: event.target.value });
										}}
										// value={contact.first_name}
										name="title"></Input>
								</FormControl>
							</Grid>
							<Grid xs={12}>
								<FormControl>
									<FormLabel>Note</FormLabel>
									{/* <Input fullWidth value={note.description} multi /> */}
									<Textarea minRows={5} value={note.description} onChange={(event) => setNote({ ...note, description: event.target.value })} />
								</FormControl>
							</Grid>
						</Grid>
					)}
				</DialogContent>
				<DialogActions>
					<Box sx={{ padding: 2 }}>
						<Button size="lg" color="primary" onClick={save} sx={{ mx: 1 }}>
							Save
						</Button>
						<Button hidden={Util.isNullOrEmpty(props.notesId)} size="lg" color="primary" onClick={deleteNote} sx={{ mx: 1 }}>
							Delete
						</Button>
						<Button size="lg" color="primary" onClick={close} sx={{ mx: 1 }}>
							Close
						</Button>
					</Box>
				</DialogActions>
			</Drawer>
		</>
	);
}
